import React from 'react';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
const TrustSection = () => {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    quote: t.trust.testimonials[0].quote,
    author: t.trust.testimonials[0].author,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80'
  }, {
    quote: t.trust.testimonials[1].quote,
    author: t.trust.testimonials[1].author,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80'
  }, {
    quote: t.trust.testimonials[2].quote,
    author: t.trust.testimonials[2].author,
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80'
  }];
  return <section className="py-12 px-4 bg-sand-50" data-id="element-337">
      <div className="container mx-auto" data-id="element-338">
        <div className="text-center mb-10" data-id="element-339">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-340">
            <div className="flex" data-id="element-341">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-[#FFD700] fill-[#FFD700]" data-id="element-342" />)}
            </div>
            <span className="font-medium text-primary text-xl" data-id="element-343">
              {t.trust.rating}
            </span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-primary mb-2" data-id="element-344">
            <span className="text-accent bg-primary px-2 py-0.5 rounded-md mr-2" data-id="element-345">
              {t.trust.headline}
            </span>{' '}
            {t.trust.subheadline}
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-346">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-custom border border-sand-200 hover:shadow-lg transition-shadow" data-id="element-347">
              <div className="flex items-center gap-3 mb-4" data-id="element-348">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-sand-200" data-id="element-349" />
                <div data-id="element-350">
                  <p className="font-medium text-primary" data-id="element-351">
                    {testimonial.author}
                  </p>
                  <div className="flex" data-id="element-352">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 text-[#FFD700] fill-[#FFD700]" data-id="element-353" />)}
                  </div>
                </div>
              </div>
              <blockquote data-id="element-354">
                <p className="text-gray-700 text-lg italic" data-id="element-355">
                  "{testimonial.quote}"
                </p>
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
};
export default TrustSection;